import NotificationService from '../../services/Notifications/NotificationService';
const state = {
  objNotiToken: {},
  notifsLoading: true,
  displayDesktopNotifications: false,
  canLoadMore: true,
  fromLoadMore: false,
  unreadCount: 0,
  userNotifications: []
};

const getters = {
  desktopNotificationsEnabled(state) {
    return state.displayDesktopNotifications;
  },

  getUserNotifications(state) {
    return state.getUserNotifications;
  }
};

const mutations = {
  setUnreadCount(store, count) {
    store.unreadCount = count;
  },
  setCanLoadMore(store, status) {
    store.canLoadMore = status;
  },
  setFromLoadMore(store, status) {
    store.fromLoadMore = status;
  },
  setNotifsLoading(store, isLoading) {
    store.notifsLoading = isLoading;
  },

  setNotiClientToken(store, objNotiToken) {
    store.objNotiToken = objNotiToken;
  },

  setDesktopNotifications(store, isEnabled) {
    store.displayDesktopNotifications = isEnabled;
  },

  setUserNotifications(store, notifications) {
    store.userNotifications = notifications;
  },

  updateNotificationsList(store, notifications) {
    let notifs = store.userNotifications;
    if (store.fromLoadMore) {
      store.userNotifications = [...notifs, ...notifications];
    } else {
      store.userNotifications = [...notifications, ...notifs];
    }
  }
};

const actions = {
  async updateUnreadCount({ commit, state }) {
    let initial = 0;
    let unread = state.userNotifications.reduce(function(
      accumulator,
      currentValue
    ) {
      return !currentValue.seen ? accumulator + 1 : accumulator + 0;
    },
    initial);
    await commit('setUnreadCount', unread);
  },

  async getNotificationsForDuration({ commit, state }, data) {
    try {
      await commit('setNotifsLoading', true);
      let response = await NotificationService.getNotificationsForDuration(
        data
      );

      await commit('setUnreadCount', response.data.body[0].unread);
      await commit('updateNotificationsList', response.data.body[0].results);
      if (state.userNotifications.length >= response.data.body[0].total) {
        await commit('setCanLoadMore', false);
      } else {
        await commit('setCanLoadMore', true);
      }
      await commit('setNotifsLoading', false);
    } catch (err) {
      await commit('setNotifsLoading', false);
    }
  },

  // eslint-disable-next-line
  async markNotifsAsSeen({ commit, state }) {
    let allNotifs = state.userNotifications;
    await NotificationService.markAllAsSeen();

    let seenNotifs = allNotifs.map(notif => {
      notif.seen = true;
      return notif;
    });
    await commit('setUserNotifications', []);
    await commit('updateNotificationsList', seenNotifs);
    await commit('setUnreadCount', 0);
  }
};

export default {
  state,
  getters,
  mutations,
  actions,
  namespaced: true
};
